import { z } from 'zod'

import {
  EMAIL_MAX_LENGTH,
  isEmailLocalPartTooLong,
} from '@/utils/validate-email'

export const contactFormValidationSchema = z.object({
  nameAndLastName: z
    .string()
    .min(1, 'Insira seu nome completo.')
    .max(255, 'O nome deve ter no máximo 255 caracteres.'),
  email: z
    .string()
    .min(1, 'Insira seu endereço de email.')
    .email('Insira um endereço de email válido.')
    .max(
      EMAIL_MAX_LENGTH,
      `O endereço de email deve ter no máximo ${EMAIL_MAX_LENGTH} caracteres.`,
    )
    .superRefine((email, ctx) => {
      const { isTooLong, maxLength } = isEmailLocalPartTooLong({
        email,
      })

      if (isTooLong) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `O email antes do @ deve ter no máximo ${maxLength} caracteres.`,
        })
      }
    }),
  subject: z
    .string()
    .min(1, 'Insira o assunto da mensagem.')
    .max(255, 'O assunto da mensagem deve ter no máximo 255 caracteres.'),
  message: z
    .string()
    .min(1, 'Insira a mensagem.')
    .max(1000, 'A mensagem deve ter no máximo 1000 caracteres.'),
})

export type ContactFormValues = z.infer<typeof contactFormValidationSchema>
